export default {
  toasts: {
    load_error: 'Laden van de tarieven mislukt',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen opgeslagen',
  },
  buttons: {
    edit: 'Bewerken',
    cancel: 'Annuleren',
    save: 'Opslaan',
  },
  rates: {
    title: 'Verwerkingsmarge',
    description:
      'Percentage in %, plus een optioneel vast bedrag en minimumbedrag per betaling. „Elke betaalmethode” geldt wanneer er geen methodespecifiek tarief bestaat.',
    default: {
      inherits:
        'Er is geen Adyen-tarief ingesteld, dus de restaurants van deze partner op de Adyen van FoodAmigos betalen het onderstaande FoodAmigos-standaardtarief. Een hier ingesteld tarief vervangt dit; een tarief dat voor één restaurant is ingesteld, blijft voorrang houden.',
      overridden:
        'Het eigen Adyen-tarief van deze partner vervangt het onderstaande FoodAmigos-standaardtarief voor zijn restaurants op de Adyen van FoodAmigos. Verwijder het om terug te vallen op het standaardtarief.',
      own_adyen:
        'Deze partner verwerkt betalingen via een eigen Adyen-account. Zijn restaurants betalen geen verwerkingskosten, tenzij hier of bij een afzonderlijk restaurant een tarief is ingesteld.',
      master:
        'Dit zijn de standaardtarieven van FoodAmigos. Elke partner op de Adyen van FoodAmigos zonder eigen Adyen-tarief gebruikt deze.',
      rows_title: 'Standaardtarieven van FoodAmigos',
    },
  },
};
